import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/699d7f3f9720f20014f1a6af/luxurynailart/src/app/gemini/page.tsx");
